<script setup lang="ts">
/** components */
import Title from '~/components/portals/SectionTitle.vue'
import TheLoader from '~/components/TheLoader.vue'

/** refs */
const showLoader = ref(true)
const iframeRef = ref<HTMLIFrameElement>()
let observer: IntersectionObserver | null = null

/** methods */
function hideLoader() {
  showLoader.value = false
}

/** lifecycle */
onMounted(() => {
  // Use nextTick to ensure the template is rendered
  nextTick(() => {
    // Use IntersectionObserver to detect when iframe is visible
    if (iframeRef.value) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Iframe is visible, hide loader after one frame
            requestAnimationFrame(() => {
              hideLoader()
            })
            observer?.disconnect()
            observer = null
          }
        })
      })

      observer.observe(iframeRef.value)
    }
  })
})

onBeforeUnmount(() => {
  // Clean up observer to prevent memory leaks
  if (observer) {
    observer.disconnect()
    observer = null
  }
})
</script>

<template>
  <div
    data-testid="events-section"
    class="mt-8 w-full max-w-content-container rounded-xl bg-white p-6 shadow-md"
  >
    <div class="w-full">
      <Title title="Events" url="/events" />

      <div class="relative">
        <div
          v-show="showLoader"
          class="absolute inset-0 z-10 flex h-[253px] w-full items-center justify-center bg-white md:h-[500px]"
        >
          <TheLoader />
        </div>

        <div class="overflow-hidden rounded-xl">
          <iframe
            ref="iframeRef"
            :src="$config.public.eventsWidgetUrl"
            width="100%"
            class="h-[253px] w-full border-none md:h-[500px]"
            data-testid="events-iframe"
            scrolling="no"
          />
        </div>
      </div>
    </div>
  </div>
</template>
